import React, { useState } from 'react';
import { FieldRow } from '../../ui/FieldRow';
import { NumberField } from '../../ui/NumberField';
import { Toggle } from '../../ui/Toggle';
import { SelectField } from '../../ui/SelectField';
type Tab = 'Touchpoints' | 'Pillars' | 'Rafts';
const tabs: Tab[] = ['Touchpoints', 'Pillars', 'Rafts'];
export function SupportStructure() {
  const [tab, setTab] = useState<Tab>('Touchpoints');
  const [internal, setInternal] = useState(true);
  const [branching, setBranching] = useState(false);
  const [raftType, setRaftType] = useState('Full Raft');
  const [raftLabel, setRaftLabel] = useState(true);
  return <div className="overflow-hidden rounded-[4px] border border-pf-line bg-white" data-id="element-647" data-mp="253lru1xw192g">
      <div role="tablist" aria-label="Support structure" className="grid grid-cols-3 border-b border-pf-line" data-id="element-648" data-mp="29w5d7l2th8ht">
        {tabs.map((t, i) => <button key={t} role="tab" type="button" aria-selected={tab === t} onClick={() => setTab(t)} className={`h-[23px] text-[12px] font-bold transition-colors duration-150 ${i > 0 ? 'border-l border-pf-line' : ''} ${tab === t ? 'bg-pf-blue-soft text-pf-blue' : 'bg-white text-[#6a6f75] hover:bg-pf-panel'}`} data-id="element-649" data-mp="1cdlseim5oo6z" data-mpi={i}>
          
            {t}
          </button>)}
      </div>
      <div className="px-[6px] py-[4px]" role="tabpanel" aria-label={tab} data-id="element-650" data-mp="qa2jbsi5lmjk">
        {tab === 'Touchpoints' && <>
            <FieldRow label="Tooth Length Min" info data-id="element-651" data-mp="matv135vugve">
              <NumberField ariaLabel="Tooth length min" value={2.55} unit="mm" data-id="element-652" data-mp="h9wa4ithn8q7" />
            </FieldRow>
            <FieldRow label="Allow Internal Supports on Model" info className="py-[3px]" labelClassName="max-w-[140px]" data-id="element-653" data-mp="cajfvd0aezdl">
              <Toggle label="Allow internal supports on model" checked={internal} onChange={setInternal} data-id="element-654" data-mp="7djidqhi74y3" />
            </FieldRow>
            <FieldRow label="Bottom Diameter" info data-id="element-655" data-mp="26n9j4lcjpkxn">
              <NumberField ariaLabel="Bottom diameter" value={1.0} unit="mm" data-id="element-656" data-mp="21rc4qkkueoni" />
            </FieldRow>
            <FieldRow label="Number of Teeth Max" info data-id="element-657" data-mp="26tfg96tok">
              <NumberField ariaLabel="Number of teeth max" value={3} decimals={0} step={1} data-id="element-658" data-mp="4rto0zdirn21" />
            </FieldRow>
          </>}
        {tab === 'Pillars' && <>
            <FieldRow label="Diameter Min" info data-id="element-659" data-mp="3m68jz0i0zxfn">
              <NumberField ariaLabel="Pillar diameter min" value={0.8} unit="mm" data-id="element-660" data-mp="3r6mucp73njgu" />
            </FieldRow>
            <FieldRow label="Diameter Max" info data-id="element-661" data-mp="irberkadlae1">
              <NumberField ariaLabel="Pillar diameter max" value={1.6} unit="mm" data-id="element-662" data-mp="ipicsiapjecd" />
            </FieldRow>
            <FieldRow label="Allow Branching" info data-id="element-663" data-mp="nobn61up6p8b">
              <Toggle label="Allow branching" checked={branching} onChange={setBranching} data-id="element-664" data-mp="9pv9ts2by0h7" />
            </FieldRow>
          </>}
        {tab === 'Rafts' && <>
            <FieldRow label="Raft Type" data-id="element-665" data-mp="2ugm7wwu7df2p">
              <SelectField ariaLabel="Raft type" value={raftType} options={['Full Raft', 'Mini Rafts', 'No Raft']} onChange={setRaftType} data-id="element-666" data-mp="2ufubjjss7dbd" />
            </FieldRow>
            <FieldRow label="Raft Thickness" info data-id="element-667" data-mp="2qyf19uetoakd">
              <NumberField ariaLabel="Raft thickness" value={2.0} unit="mm" data-id="element-668" data-mp="2r1axneb0ur6p" />
            </FieldRow>
            <FieldRow label="Z-Height Lift" info data-id="element-669" data-mp="2m27rfqjb2ex5">
              <NumberField ariaLabel="Z-height lift" value={5.0} unit="mm" data-id="element-670" data-mp="30xnnu27cymwp" />
            </FieldRow>
            <FieldRow label="Raft Label" data-id="element-671" data-mp="2vy19tqjph2mu">
              <Toggle label="Raft label" checked={raftLabel} onChange={setRaftLabel} data-id="element-672" data-mp="2vw84cektwogf" />
            </FieldRow>
          </>}
      </div>
    </div>;
}